import { render, staticRenderFns } from "./billing-address-card.vue?vue&type=template&id=22abe5fc"
import script from "./billing-address-card.vue?vue&type=script&lang=js"
export * from "./billing-address-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports